import BaseComponent from 'scripts/BaseComponent.js';
import Accordion from 'scripts/Accordion.js';

export default class SubmenuLinks extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {};

    this.dom = {
      $component: component,
    };

    this.state = {
      accordion: null,
    };

    this.mount();
    this.init();
  }

  mount() {
    super.mount();
  }

  init() {
    const { dom, state } = this;
    state.accordion = new Accordion(dom.$component);
  }
}
